import layoutAdmin from "@/layouts/layoutAdmin.vue";
import dashboard from "@/views/module/dashboard/dashboard.vue";
import productSetup from "@/views/module/inventory/productManagement/productSetup.vue";
import productList from "@/views/module/inventory/productManagement/productList.vue";
import supplierSetup from "@/views/module/inventory/supplierManagement/supplierSetup.vue";
import invRequistion from "@/views/module/inventory/requistionManagement/invRequistion.vue";
import invRequistionRecord from "@/views/module/inventory/requistionManagement/invRequistionRecord.vue";
import viewRequisition from "@/views/module/inventory/requistionManagement/viewRequisition.vue";
import customerSetup from "@/views/module/inventory/customerManagement/customerSetup.vue";
import issueEntrySetup from "@/views/module/inventory/directIssueManagement/issueEntrySetup.vue";
import issueEntryRecord from "@/views/module/inventory/directIssueManagement/issueEntryRecord.vue";
import directReceive from "@/views/module/inventory/receiveManagement/directRecevie.vue";
import directRecevieRecord from "@/views/module/inventory/receiveManagement/directRecevieRecord.vue";
import viewDirectReceive from "@/views/module/inventory/receiveManagement/viewDirectReceive.vue";
import poReceive from "@/views/module/inventory/receiveManagement/poReceive.vue";
import poReceiveRecord from "@/views/module/inventory/receiveManagement/poReceiveRecord.vue";
import viewPoReceive from "@/views/module/inventory/receiveManagement/viewPoReceive.vue";
import poLandedCost from "@/views/module/inventory/receiveManagement/poLandedCost.vue";
import poLandedCostRecord from "@/views/module/inventory/receiveManagement/poLandedCostRecord.vue";
import viewPoLandedCost from "@/views/module/inventory/receiveManagement/viewPoLandedCost.vue";
import lcReceive from "@/views/module/inventory/receiveManagement/lcReceive.vue";
import lcReceiveRecord from "@/views/module/inventory/receiveManagement/lcReceiveRecord.vue";
import lcReceiveDetails from "@/views/module/inventory/receiveManagement/lcReceiveDetails.vue";
import addTransfer from "@/views/module/inventory/itemTransferManagement/addTransfer.vue";
import transferRecord from "@/views/module/inventory/itemTransferManagement/transferRecord.vue";
import inventoryRecords from "@/views/module/inventory/inventoryRecords.vue";
import inventoryDetails from "@/views/module/inventory/inventoryDetails.vue";
import requisitionDeliverySetup from "@/views/module/inventory/deliveryManagement/requisitionDeliverySetup.vue";
import requisitionDeliveryRecords from "@/views/module/inventory/deliveryManagement/requisitionDeliveryRecords.vue";
import salesInvoiceDeliverySetup from "@/views/module/inventory/deliveryManagement/salesInvoiceDeliverySetup.vue";
import salesInvoiceDeliveryRecords from "@/views/module/inventory/deliveryManagement/salesInvoiceDeliveryRecords.vue";
import gatePassSetup from "@/views/module/inventory/gatePassManagement/gatePassSetup.vue";
import gatePassRecords from "@/views/module/inventory/gatePassManagement/gatePassRecords.vue";
import gatePassInvoice from "@/views/module/inventory/gatePassManagement/gatePassInvoice.vue";
import requisitionDeliveryInvoice from "@/views/module/inventory/deliveryManagement/requisitionDeliveryInvoice.vue";
import salesInvoiceDeliveryInvoice from "@/views/module/inventory/deliveryManagement/salesInvoiceDeliveryInvoice.vue";
import viewIssueEntryInvoice from "@/views/module/inventory/directIssueManagement/viewIssueEntryInvoice.vue";
// reportsManagement
import productMappingReport from "@/views/module/inventory/reports/productMappingReports.vue";
import supplierMappingReport from "@/views/module/inventory/reports/supplierMappingReports.vue";
import stockReport from "@/views/module/inventory/reports/stockReports.vue";
import itemReceivedReport from "@/views/module/inventory/reports/itemReceivedReport.vue";
import poReceiveReport from "@/views/module/inventory/reports/poReceiveReport.vue";
import lcReceiveReport from "@/views/module/inventory/reports/lcReceiveReport.vue";
import directReceiveReport from "@/views/module/inventory/reports/directReceiveReport.vue";
import generalRequisitionReport from "@/views/module/inventory/reports/generalRequisitionReport.vue";
import issueReport from "@/views/module/inventory/reports/issueReport.vue";
import deliveryReport from "@/views/module/inventory/reports/deliveryReport.vue";
import TransferReport from "@/views/module/inventory/reports/transferReport.vue";
import returnReport from "@/views/module/inventory/reports/returnReport.vue";
import gatepassReport from "@/views/module/inventory/reports/gatepassReport.vue";
import transferrequestView from "@/views/module/inventory/itemTransferManagement/transferRecordView.vue";
import inventorySummaryReports from "@/views/module/inventory/reports/inventorySummaryReports.vue";
import inventoryStockAlertReport from "@/views/module/inventory/reports/inventoryStockAlertReport.vue";

//Return Management
import purchaseReturn from "@/views/module/inventory/returnManagement/purchaseReturn.vue";
import purchaseReturnRecord from "@/views/module/inventory/returnManagement/purchaseReturnRecord.vue";
import purchaseReturnDetails from "@/views/module/inventory/returnManagement/purchaseReturnDetails.vue";

import salesReturn from "@/views/module/inventory/returnManagement/salesReturn.vue";
import salesReturnRecord from "@/views/module/inventory/returnManagement/salesReturnRecord.vue";
import salesReturnDetails from "@/views/module/inventory/returnManagement/salesReturnDetails.vue";

import productionRequisitionDeliverySetup from "@/views/module/inventory/deliveryManagement/productionRequisitionDelivery.vue";
import productionRequisitionDeliveryRecords from "@/views/module/inventory/deliveryManagement/productionRequisitionDeliveryRecords.vue";
import productionRequisitionDeliveryDetails from "@/views/module/inventory/deliveryManagement/productionRequisitionDeliveryDetails.vue";
import productionReceive from "@/views/module/inventory/receiveManagement/productionReceive.vue";
import productionReceiveRecords from "@/views/module/inventory/receiveManagement/productionReceiveList.vue";
import productionReceiveDetails from "@/views/module/inventory/receiveManagement/productionReceiveDetails.vue";
import stockReportsWithValues from "@/views/module/inventory/reports/stockReportsWithValues.vue";
import sampleDeliverySetup from "@/views/module/inventory/deliveryManagement/sampleDeliverySetup.vue";
import sampleDeliveryRecords from "@/views/module/inventory/deliveryManagement/sampleDeliveryRecords.vue";
import sampleDeliveryInvoice from "@/views/module/inventory/deliveryManagement/sampleDeliveryInvoice.vue";
import itemsList from "@/views/module/inventory/reports/itemsList.vue";
import damageReport from "@/views/module/inventory/reports/damageReport.vue";


export default [
  {
    path: "/inventory",
    name: "inventory",
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: "Inventory",
    },
    children: [
      {
        path: "dashboard",
        meta: {
          breadcrumb: ["Dashboard"],
        },
        component: dashboard,
      },
      

      {
        path: "add-supplier",
        name: "add-supplier",
        meta: {
          breadcrumb: ["Supplier", "Add Supplier"],
        },
        component: supplierSetup,
      },
      {
        path: "add-requistion",
        name: "add-requistion",
        meta: {
          breadcrumb: ["Requisition Management", "Add Requisition"],
        },
        component: invRequistion,
      },
      {
        path: "requistion-record",
        name: "requistion-record",
        meta: {
          breadcrumb: ["Requisition Management", "Requisition Record"],
        },
        component: invRequistionRecord,
      },
      {
        path: "view-requisition/:id",
        name: "view-requisition",
        meta: {
          breadcrumb: ["General Requisition", "View Requisition"],
        },
        component: viewRequisition,
      },
      {
        path: "add-customer",
        name: "add-customer",
        meta: {
          breadcrumb: ["Customer", "Add Customer"],
        },
        component: customerSetup,
      },
      {
        path: "issue-entry",
        name: "issue-entry",
        meta: {
          breadcrumb: ["Direct Issue Management", "Issue Entry"],
        },
        component: issueEntrySetup,
      },
      {
        path: "issue-record",
        name: "issue-record",
        meta: {
          breadcrumb: ["Direct Issue Management", "Issue Record"],
        },
        component: issueEntryRecord,
      },
      {
        path: "view-issue-invoice",
        name: "view-issue-invoice",
        meta: {
          breadcrumb: ["Direct Issue Management", "View Issue Invoice"],
        },
        component: viewIssueEntryInvoice,
      },
      {
        path: "direct-receive",
        name: "direct-receive",
        meta: {
          breadcrumb: ["Direct Receive Management", "Direct Receive"],
        },
        component: directReceive,
      },
      {
        path: "direct-receive-records",
        name: "direct-receive-records",
        meta: {
          breadcrumb: ["Direct Receive Management", "Direct Record"],
        },
        component: directRecevieRecord,
      },
      {
        path: "view-direct-receive/:id",
        name: "view-direct-receive",
        meta: {
          breadcrumb: ["Direct Receive Management", "View Direct Receive"],
        },
        component: viewDirectReceive,
      },
      {
        path: "po-landed-cost",
        name: "po-landed-cost",
        meta: {
          breadcrumb: ["PO Landed Cost", "PO Landed Cost"],
        },
        component: poLandedCost,
      },
      {
        path: "po-landed-cost-records",
        name: "po-landed-cost-records",
        meta: {
          breadcrumb: ["PO Landed Cost", "PO Landed Cost Records"],
        },
        component: poLandedCostRecord,
      },
      {
        path: "view-po-landed-cost/:id",
        name: "view-po-landed-cost",
        meta: {
          breadcrumb: ["PO Landed Cost", "View PO Landed Cost"],
        },
        component: viewPoLandedCost,
      },
      {
        path: "po-receive",
        name: "po-receive",
        meta: {
          breadcrumb: ["PO Receive Management", "PO Receive"],
        },
        component: poReceive,
      },
      {
        path: "po-receive-records",
        name: "po-receive-records",
        meta: {
          breadcrumb: ["PO Recieve Management", "PO Record"],
        },
        component: poReceiveRecord,
      },
      {
        path: "view-po-receive/:id",
        name: "view-po-receive",
        meta: {
          breadcrumb: ["PO Receive Management", "View PO Receive"],
        },
        component: viewPoReceive,
      },
      {
        path: "lc-receive",
        name: "lc-receive",
        meta: {
          breadcrumb: ["LC Receive Management", "LC Receive"],
        },
        component: lcReceive,
      },
      {
        path: "lc-receive-records",
        name: "lc-receive-records",
        meta: {
          breadcrumb: ["LC Recieve Management", "LC Receive Record"],
        },
        component: lcReceiveRecord,
      },

       {
        path: "lc-receive-details/:id",
        name: "lc-receive-details",
        meta: {
          breadcrumb: ["LC Recieve Management", "LC Receive Details"],
        },
        component: lcReceiveDetails,
      },
      
      //Item Transfer
      {
        path: "add-transfer",
        name: "add-transfer",
        meta: {
          breadcrumb: ["Item Transfer", "Add Transfer"],
        },
        component: addTransfer,
      },
      {
        path: "transfer-record",
        name: "transfer-record",
        meta: {
          breadcrumb: ["Item Transfer", "Transfer Record"],
        },
        component: transferRecord,
      },

      // Inventory Records
      {
        path: "records",
        name: "inventory-records",
        meta: {
          breadcrumb: ["Inventory", "Inventory Records"],
        },
        component: inventoryRecords,
      },

      // Inventory Details (Transaction Log)
      {
        path: "details",
        name: "inventory-details",
        meta: {
          breadcrumb: ["Inventory", "Inventory Details"],
        },
        component: inventoryDetails,
      },
      
      //Delivery Management

      {
        path: "requisition-delivery",
        name: "requisition-delivery",
        meta: {
          breadcrumb: ["Inventory", "Requisition Delivery Setup"],
        },
        component: requisitionDeliverySetup,
      },
      {
        path: "requisition-delivery-records",
        name: "requisition-delivery-records",
        meta: {
          breadcrumb: ["Inventory", "Requisition Delivery Records"],
        },
        component: requisitionDeliveryRecords,
      },
      {
        path: "view-requisition-delivery-invoice",
        name: "view-requisition-delivery-invoice",
        meta: {
          breadcrumb: ["Inventory", "Requisition Delivery Invoice"],
        },
        component: requisitionDeliveryInvoice,
      },

      
      {
        path: "sale-delivery",
        name: "sale-delivery",
        meta: {
          breadcrumb: ["Inventory", "Sales Invoice Delivery Setup"],
        },
        component: salesInvoiceDeliverySetup,
      },
      {
        path: "sale-delivery-records",
        name: "sale-delivery-records",
        meta: {
          breadcrumb: ["Inventory", "Sales Delivery Records"],
        },
        component: salesInvoiceDeliveryRecords,
      },
      {
        path: "sample-delivery",
        name: "sample-delivery",
        meta: {
          breadcrumb: ["Inventory", "Samples Delivery Setup"],
        },
        component: sampleDeliverySetup,
      },
      {
        path: "sample-delivery-records",
        name: "sample-delivery-records",
        meta: {
          breadcrumb: ["Inventory", "Samples Delivery Records"],
        },
        component: sampleDeliveryRecords,
      },
      {
        path: "view-sale-delivery-invoice",
        name: "view-sale-delivery-invoice",
        meta: {
          breadcrumb: ["Inventory", "Sales Delivery Invoice"],
        },
        component: salesInvoiceDeliveryInvoice,
      },
      {
        path: "view-sample-delivery-invoice",
        name: "view-sample-delivery-invoice",
        meta: {
          breadcrumb: ["Inventory", "Sample Delivery Invoice"],
        },
        component: sampleDeliveryInvoice,
      },

      //Gate Pass management  

      {
        path: "add-gate-pass",
        name: "add-gate-pass",
        meta: {
          breadcrumb: ["Inventory", "Gate Pass Setup"],
        },
        component: gatePassSetup,
      },
      {
        path: "gate-pass-record",
        name: "gate-pass-record",
        meta: {
          breadcrumb: ["Inventory", "Gate Pass Records"],
        },
        component: gatePassRecords,
      },
      {
        path: "view-gate-pass-invoice",
        name: "view-gate-pass-invoice",
        meta: {
          breadcrumb: ["Inventory", "Gate Pass Invoice"],
        },
        component: gatePassInvoice,
      },
      {
        path: "product-mapping-report",
        name: "product-mapping-report",
        meta: { breadcrumb: ["Product Mapping Reports"] },
        component: productMappingReport,
      },
      {
        path: "supplier-mapping-report",
        name: "supplier-mapping-report",
        meta: { breadcrumb: ["Supplier Mapping Reports"] },
        component: supplierMappingReport,
      },
      {
        path: "stock-report",
        name: "stock-report",
        meta: { breadcrumb: ["Stock Reports"] },
        component: stockReport,
      },
      {
        path: "item-received-report",
        name: "item-received-report",
        meta: { breadcrumb: ["Item Received Report"] },
        component: itemReceivedReport,
      },
      {
        path: "po-receive-report",
        name: "po-receive-report",
        meta: { breadcrumb: ["PO Receive Report"] },
        component: poReceiveReport,
      },
      {
        path: "lc-receive-report",
        name: "lc-receive-report",
        meta: { breadcrumb: ["L/C Receive Report"] },
        component: lcReceiveReport,
      },
      {
        path: "dr-receive-report",
        name: "dr-receive-report",
        meta: { breadcrumb: ["Direct Receive Report"] },
        component: directReceiveReport,
      },
      {
        path: "general-requisition-report",
        name: "general-requisition-report",
        meta: { breadcrumb: ["General Requisition Report"] },
        component: generalRequisitionReport,
      },
      {
        path: "issue-report",
        name: "issue-report",
        meta: { breadcrumb: ["Issue Report"] },
        component: issueReport,
      },
      {
        path: "item-list-report",
        name: "item-list-report",
        meta: { breadcrumb: ["Item List Report"] },
        component: itemsList,
      },
      {
        path: "delivery-report",
        name: "delivery-report",
        meta: { breadcrumb: ["Delivery Report"] },
        component: deliveryReport,
      },
      {
        path: "transfer-report",
        name: "transfer-report",
        meta: { breadcrumb: ["Transfer Report"] },
        component: TransferReport,
      },
      {
        path: "damage-report",
        name: "damage-report",
        meta: { breadcrumb: ["Damage Report"] },
        component: damageReport,
      },
      {
        path: "return-report",
        name: "return-report",
        meta: { breadcrumb: ["Return Report"] },
        component: returnReport,
      },
      {
        path: "gate-pass-report",
        name: "gate-pass-report",
        meta: { breadcrumb: ["Gatepass Report"] },
        component: gatepassReport,
      },
      {
        path: "stock-report-values",
        name: "stock-report-values",
        meta: { breadcrumb: ["Stock Reports With Values"] },
        component: stockReportsWithValues,
      },
      {
        path: "transfer-record-view",
        name: "transfer-record-view",
        meta: {
          breadcrumb: ["Inventory", "Transfer Record View"],
        },
        component: transferrequestView,
      },
      {
        path: "purchase-return",
        name: "purchase-return",
        meta: {
          breadcrumb: ["Inventory", "Purchase Return"],
        },
        component: purchaseReturn,
      },
      {
        path: "purchase-return-record",
        name: "purchase-return-record",
        meta: {
          breadcrumb: ["Inventory", "Purchase Return List"],
        },
        component: purchaseReturnRecord,
      },
      {
        path: "purchase-return-details/:id",
        name: "purchase-return-details",
        meta: {
          breadcrumb: ["Inventory", "Purchase Return Details"],
        },
        component: purchaseReturnDetails,
      },

      {
        path: "sales-return",
        name: "sales-return",
        meta: {
          breadcrumb: ["Inventory", "Sales Return"],
        },
        component: salesReturn,
      },
      {
        path: "sales-return-record",
        name: "sales-return-record",
        meta: {
          breadcrumb: ["Inventory", "Sales Return List"],
        },
        component: salesReturnRecord,
      },
      {
        path: "sales-return-details/:id",
        name: "sales-return-details",
        meta: {
          breadcrumb: ["Inventory", "Sales Return Details"],
        },
        component: salesReturnDetails,
      },

      {
        path: "summary-report",
        name: "summary-report",
        meta: {
          breadcrumb: ["Inventory", "Summary Report"],
        },
        component: inventorySummaryReports,
      },
      {
        path: "stock-alert-report",
        name: "stock-alert-report",
        meta: {
          breadcrumb: ["Inventory", "Stock Alert Report"],
        },
        component: inventoryStockAlertReport,
      },
      {
        path: "production-requisition-delivery",
        name: "production-requisition-delivery",
        meta: {
          breadcrumb: ["Inventory", "Production Requisition Delivery"],
        },
        component: productionRequisitionDeliverySetup,
      },
      {
        path: "production-requisition-delivery-records",
        name: "production-requisition-delivery-records",
        meta: {
          breadcrumb: ["Inventory", "Production Requisition Delivery Records"],
        },
        component: productionRequisitionDeliveryRecords,
      },
      {
        path: "production-requisition-delivery-details/:id",
        name: "production-requisition-delivery-details",
        meta: {
          breadcrumb: ["Inventory", "Production Requisition Delivery Details"],
        },
        component: productionRequisitionDeliveryDetails,
      },
      {
        path: "production-receive/:id?",
        name: "production-receive",
        meta: {
          breadcrumb: ["Inventory", "Production Receive"],
        },
        component: productionReceive,
      },
      {
        path: "production-receive-records",
        name: "production-receive-records",
        meta: {
          breadcrumb: ["Inventory", "Production Receive Records"],
        },
        component: productionReceiveRecords,
      },
      {
        path: "production-receive-details/:id",
        name: "production-receive-details",
        meta: {
          breadcrumb: ["Inventory", "Production Receive Details"],
        },
        component: productionReceiveDetails,
      },

    ],
  },
];
